module.exports = __webpack_public_path__ + "img/recognition-header-bubble.03003ead.svg";